export default "__VITE_ASSET__DfaN_Che__"